import { Link } from '@snack-uikit/link';
import styles from "./styles.module.css";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function Place(_ref) {
  var href = _ref.href,
    title = _ref.title,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: href ? /*#__PURE__*/_jsx(Link, {
      href: href,
      onClick: onClick,
      className: styles.place,
      target: "_blank",
      text: title,
      size: "l",
      appearance: "neutral",
      insideText: true
    }) : /*#__PURE__*/_jsx("span", {
      className: styles.place,
      children: title
    })
  });
}